module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-10.35dd9965.jpg";